// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3FgGt","box":"WorkspacesBox_box__2YPOE","node":"WorkspacesBox_node__AVObZ"};